<mat-form-field class="custom-autocomplete" [floatLabel]="asFormsControl().floatingLabelNever && 'never'">
    <input
        matInput
        #input
        type="text"
        autocomplete="off"
        [placeholder]="asFormsControl().placeholder"
        [matAutocomplete]="autoComplete"
        [disabled]="asFormsControl().disabled"

        (input)="filterOptions($event)"
        (paste)="filterOptionsOnPaste($event)"
    >
    <i class="fa fa-caret-down"></i>
    <mat-autocomplete
        #autoComplete="matAutocomplete"

        class="country-autocomplete-panel"

        (optionSelected)="selectOption($event)"
        (opened)="onTouched && onTouched()"
    >
        <mat-option
            *ngFor="let option of autocompleteOptions | async; trackBy: trackById"
            [value]="option.value">
            <div class="select-item" [ngClass]="{'select-item-with-icon': option.classes}">
                <span [ngClass]="option.classes"></span>
                <span> {{option.label}}</span>
            </div>
        </mat-option>
    </mat-autocomplete>
</mat-form-field>
<div *ngIf='asFormsControl().errors.length > 0' class="form-text text-danger">
    <span *ngFor="let error of asFormsControl().errors">{{error}}</span>
</div>

